//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getCuralateProductCatalogs } from '@apis/universal-image-actions/universalImageActionsApi';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useProductCatalogsQuery = () =>
  useQuery({
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsProducts,
      QueryKeyConstants.UniversalImageActionsProductsProductCatalogs,
    ],
    queryFn: async ({ signal }) => await getCuralateProductCatalogs({ signal }),
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
